export default "__VITE_ASSET__4e3d98a0__"